import type * as React from "react"
import { Cell, Pie, PieChart } from "recharts"
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart"
import type { Result } from "@/utils/types"
import { languages } from "@/lib/utils"

type LanguagePieProps = {
  results: Result[]
  total_runs: number
}

export const LanguagePie: React.FC<LanguagePieProps> = ({ results }) => {
  const colors = ["#729FCF", "#F5A742", "#EA6B6B", "#85BC87", "#B0B0B0"]

  const counts = results.reduce<Record<string, number>>((acc, result) => {
    const lang = result.language || "other"
    acc[lang] = (acc[lang] || 0) + 1
    return acc
  }, {})

  const sorted = Object.entries(counts).sort((a, b) => b[1] - a[1])

  const top = sorted.slice(0, 4).map(([language, count], index) => ({
    language: languages[language as keyof typeof languages].name,
    count: count,
    color: colors[index],
  }))

  const othersCount = sorted.slice(4).reduce((sum, [, count]) => sum + count, 0)

  const chartData = othersCount > 0 ? [...top, { language: "other", count: othersCount, color: colors[4] }] : top

  return (
    <ChartContainer config={{}} className="w-35 h-35">
      <PieChart>
        <ChartTooltip cursor={false} content={<ChartTooltipContent hideLabel />} />
        <Pie data={chartData} dataKey="count" nameKey="language" innerRadius={25} strokeWidth={5}>
          {chartData.map((entry, index) => (
            <Cell key={`slice-${index.toString()}`} fill={entry.color} />
          ))}
          {/* <Label
            content={({ viewBox }) => {
              if (viewBox && "cx" in viewBox && "cy" in viewBox) {
                return (
                  <text x={viewBox.cx} y={viewBox.cy} textAnchor="middle" dominantBaseline="middle">
                    <tspan x={viewBox.cx} y={viewBox.cy} className="text-white fill-white text-base font-bold">
                      {total_runs}
                    </tspan>
                  </text>
                )
              }
              return null
            }}
          /> */}
        </Pie>
      </PieChart>
    </ChartContainer>
  )
}
